import styled from 'styled-components';

import { BaseButton } from '@/ui/Button/type/default/styles/button';
import { Icon } from '@/ui/Icon';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/ui/DropdownMenu';
import { PageVariantDeprecated as PageVariant } from '@/features/course/admin/types/page';

const DropdownMenuContentStyled = styled(DropdownMenuContent)`
  width: 304px;
  z-index: 100;
`;

const DropdownMenuItemStyled = styled(DropdownMenuItem)`
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 16px;

  & div {
    max-height: 72px;
  }
`;

const OptionTitleStyled = styled.div`
  ${({ theme }) => theme.typography.body3};
  color: ${({ theme }) => theme.colors.neutral.onBackground};
`;

const OptionCaptionStyled = styled.div`
  ${({ theme }) => theme.typography.caption};
  color: ${({ theme }) => theme.colors.neutral.outline2};
`;

export const AddAssessmentPageButton = ({ onAddClick }: { onAddClick: (type: PageVariant) => void }): JSX.Element => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <BaseButton type="button" variant="neutral">
          <Icon icon="plus" size="lg" />
        </BaseButton>
      </DropdownMenuTrigger>
      <DropdownMenuContentStyled variant="subtle" side="bottom" align="start">
        <DropdownMenuItemStyled variant="subtle" onSelect={() => onAddClick(PageVariant.PRACTICAL_ASSESSMENT_TEXT)}>
          <Icon icon={['far', 'pen-line']} />
          <div>
            <OptionTitleStyled>Free text question</OptionTitleStyled>
            <OptionCaptionStyled>Participant writes free text to complete</OptionCaptionStyled>
          </div>
        </DropdownMenuItemStyled>
        <DropdownMenuItemStyled variant="subtle" onSelect={() => onAddClick(PageVariant.PRACTICAL_ASSESSMENT_DOCUMENT)}>
          <Icon icon={['far', 'file-upload']} />
          <div>
            <OptionTitleStyled>Document upload</OptionTitleStyled>
            <OptionCaptionStyled>Participant uploads document to complete</OptionCaptionStyled>
          </div>
        </DropdownMenuItemStyled>
        <DropdownMenuItemStyled variant="subtle" onSelect={() => onAddClick(PageVariant.PRACTICAL_ASSESSMENT_VIDEO)}>
          <Icon icon={['far', 'video']} />
          <div>
            <OptionTitleStyled>Video upload</OptionTitleStyled>
            <OptionCaptionStyled>Learner uploads video to complete</OptionCaptionStyled>
          </div>
        </DropdownMenuItemStyled>
      </DropdownMenuContentStyled>
    </DropdownMenu>
  );
};
